import { z } from 'zod'

export const TableLayoutSchema = z.object({
  order: z.array(z.string()),
  hidden: z.array(z.string()),
  pinned: z.array(z.string()),
  widths: z.record(z.string(), z.number().positive().finite()),
  entry_width: z.number().positive().finite().nullable(),
  row_heights: z.record(z.string(), z.number().positive().finite()).default({}),
})
export type TableLayout = z.infer<typeof TableLayoutSchema>
export const defaultTableLayout: TableLayout = { order: [], hidden: [], pinned: [], widths: {}, entry_width: null, row_heights: {} }

/** Ignore removed IDs and append new columns without disturbing the saved order. */
export function orderedColumns(ids: string[], layout: TableLayout): string[] {
  const current = new Set(ids)
  return [...new Set([...layout.order.filter((id) => current.has(id)), ...ids])]
}

export function visibleColumnOrder(ids: string[], layout: TableLayout): string[] {
  const visible = orderedColumns(ids, layout).filter((id) => !layout.hidden.includes(id))
  return [...visible.filter((id) => layout.pinned.includes(id)), ...visible.filter((id) => !layout.pinned.includes(id))]
}

export function moveColumn(ids: string[], layout: TableLayout, from: string, to: string): TableLayout {
  const order = orderedColumns(ids, layout)
  const index = order.indexOf(to)
  if (from === to || index < 0 || !order.includes(from)) return layout
  order.splice(order.indexOf(from), 1)
  order.splice(index, 0, from)
  return { ...layout, order }
}
